var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueFVat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.926,
    height: 22.75,
    viewBox: "0 0 15.926 22.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_180",
    "data-name": "Group 180",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 8.261,
    transform: "translate(3.398 8.016)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 5.582,
    transform: "translate(3.398 10.76)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 3.126,
    transform: "translate(3.398 13.504)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_181",
    "data-name": "Group 181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11669",
    "data-name": "Path 11669",
    d: "M2.835,7.434H7.11v-4.6",
    transform: "translate(-2.835 -2.835)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11670",
    "data-name": "Path 11670",
    d: "M14.844,24.585H5.752a2.918,2.918,0,0,1-2.917-2.917V5.752A2.917,2.917,0,0,1,5.752,2.835h9.092a2.917,2.917,0,0,1,2.917,2.917V21.667a2.917,2.917,0,0,1-2.917,2.917Z",
    transform: "translate(-2.835 -2.835)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11671",
    "data-name": "Path 11671",
    d: "M2.835,74.515v1.646a2.917,2.917,0,0,0,2.917,2.917h9.092a2.917,2.917,0,0,0,2.917-2.917V74.515Z",
    transform: "translate(-2.835 -57.328)",
    fill: "#6f87f6",
    stroke: "#6f87f6",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11672",
    "data-name": "Path 11672",
    d: "M2.835,74.515v1.646a2.917,2.917,0,0,0,2.917,2.917h9.092a2.917,2.917,0,0,0,2.917-2.917V74.515Z",
    transform: "translate(-2.835 -57.328)",
    fill: "none",
    stroke: "#6f87f6",
    strokeLinecap: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("text", {
    id: "F-VAT",
    transform: "translate(1.963 20.32)",
    fill: "#fff",
    fontSize: 4,
    fontFamily: "RocGrotesk-Regular, Roc Grotesk",
    letterSpacing: "0.025em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "F-VAT")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFVat);
export default __webpack_public_path__ + "static/media/blue-f_Vat.cd458c420c40f26a16cfb37ad7a022d0.svg";
export { ForwardRef as ReactComponent };